export default "__VITE_ASSET__CnNDtYPK__"